import React from 'react';
import Loadable from 'react-loading-overlay';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import Row from '../../../../shared/components/Row';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';
import { bindActionCreators } from 'redux';
import * as navigationActions from '../../../../shared/utils/NavigationActions';
import { MachineUpdateRequest } from './machine-update/MachineUpdateRequest';
import { MachineUpdateTask } from './machine-update/MachineUpdateTask';
import { PsMachine } from '../../PsMachine';
import { MachineFormValues } from '../MachineFormValues';
import { MachineForm } from '../MachineForm';
import { MachineDetailRequest } from './machine-detail/MachineDetailRequest';
import { MachineDetailTask } from './machine-detail/MachineDetailTask';
import DocumentsCard from '../../../../documents/components/DocumentsCard';
import CardMessages from '../../../../messages-notifications/messages/to-refactor/card/CardMessages';
import StateManager from '../../../../shared/utils/StateManager';
import { PsQrWorkerToken } from '../../../worker/PsQrWorkerToken';
import { PsQrMachineToken } from '../../PsQrMachineToken';
import { QrMachineTokenTask } from '../../../../shared/components/predefined-fields/resource-contractor-schema/machine-qr/QrMachineTokenTask';
import { QrMachineTokenRequest } from '../../../../shared/components/predefined-fields/resource-contractor-schema/machine-qr/QrMachineTokenRequest';

class MachineUpdate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            machine: null,
            loading: false,
            machineInitialValues: MachineFormValues.null(),
            refreshDocuments: false,
            refreshQrToken: false,
            qrTokenLoading: false,
        };
    }

    componentDidMount() {
        this.getMachine();
    }

    handleSetRefreshDocuments = (refresh) => {
        this.setState({ refreshDocuments: refresh });
    };

    handleSetRefreshQrToken = (refresh) => {
        this.setState({ refreshQrToken: refresh });
    };

    handleTokenLoading = (loading) => {
        this.setState({ qrTokenLoading: loading });
    };

    render() {
        const {
            machine,
            loading,
            machineInitialValues,
            refreshDocuments,
            refreshQrToken,
            qrTokenLoading,
        } = this.state;

        if ( !machine ) return null;

        const { currentUser } = this.props;
        const machineId = machine.id();
        const machineCompanyId = machine.companyId();
        const initialValues = machineInitialValues.initialValues();

        return (
            <React.Fragment>
                <Row clearfix>
                    <MachineForm
                        title={I18nUtils.tr('TR_EDITAR_MAQUINA')}
                        initialValues={initialValues}
                        onSubmit={this.updateMachine}
                        canWrite={
                            currentUser.isAdmin() || currentUser.isContractorsManager() || currentUser.isOutsourcesManager()
                        }
                        canSendInfoEmail={currentUser.isAdmin() || currentUser.isOutsourcesManager()}
                        machineId={machineId}
                        contractorId={currentUser.contractorId()}
                        handleSetRefreshQrToken={this.handleSetRefreshQrToken}
                        refreshQrToken={refreshQrToken}
                        handleTokenLoading={this.handleTokenLoading}
                        loading={loading || qrTokenLoading}
                    />
                </Row>
                <DocumentsCard
                    id={StateManager.DOC_MACHINE_DETAIL_ID + machineId}
                    title={I18nUtils.tr('TR_DOCUMENTOS')}
                    machineId={machineId}
                    refreshDocuments={refreshDocuments}
                    handleSetRefreshDocuments={this.handleSetRefreshDocuments}
                />
                <Row clearfix>
                    <CardMessages
                        machineId={machineId}
                        companyId={machineCompanyId}
                        colWidth="col-md-12"
                        canAddMessage={!currentUser.isOutsourcesViewer()}
                        canResponseMessage={!currentUser.isOutsourcesViewer()}
                    />
                </Row>
            </React.Fragment>
        );
    }

    getMachine = () => {
        const { id, currentUser, appendBreadcrumb } = this.props;
        const request = new MachineDetailRequest();

        request.setId(id);

        new MachineDetailTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const machine = PsMachine.fromAPIMachine(res.data, currentUser);
                const machineInitialValues = MachineFormValues.fromMachine(machine, currentUser.contractorId());
                appendBreadcrumb(machine);
                this.setState({ machine, machineInitialValues });
            })
            .onFail((error) => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    updateMachine = (values) => {
        const {
            machine,
            machineInitialValues,
        } = this.state;

        // comprobación de si ha cambiado un esquema para refrescar el listado de documentos
        let needsRefreshDocuments = false;
        const initialValues = machineInitialValues.initialValues();
        initialValues.contractorSchema.forEach((contractorSchema, index) => {
            if ( ( !needsRefreshDocuments && values.contractorSchema[index] &&
                    values.contractorSchema[index].length !== contractorSchema.length ) ||
                values.contractorSchema[index] !== contractorSchema ) {
                needsRefreshDocuments = true;
            }
        });

        this.setState({ loading: true });
        const request = new MachineUpdateRequest(values, machine);
        new MachineUpdateTask(request)
            .onSuccess(() => {
                this.setState({ loading: false });
                Alert.success(I18nUtils.tr('TR_MAQUINA_EDITADA_CORRECTAMENTE'));
                if ( needsRefreshDocuments ) {
                    this.handleSetRefreshDocuments(true);
                }
                this.handleSetRefreshQrToken(true);
            })
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

const mapDispatchToProps = (dispatch) => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const MachineUpdateContent = connect(mapStateToProps, mapDispatchToProps)(MachineUpdate);

MachineUpdateContent.propTypes = {
    id: PropTypes.number.isRequired,
    appendBreadcrumb: PropTypes.func,
};

MachineUpdateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/update/MachineUpdateContent.jsx